import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-patients-intro',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './patients-intro.component.html',
  styleUrl: './patients-intro.component.scss'
})
export class PatientsIntroComponent {

}
